export type TradingOfferSortOption = 'price' | 'date' | 'shareClass';

type SortOptionConfig = {
  label: string;
  value: TradingOfferSortOption;
};

export const tradingOffersSortOptions: SortOptionConfig[] = [
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'ShareClass',
    value: 'shareClass',
  },
];

export default tradingOffersSortOptions;
